import axios from "axios";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";

const endpoint = "https://mikroapp.testwebspace.co.uk";
const token = Cookies.get("token");

export const useGetRequest = (path) => {
  const [status, setStatus] = useState("idle");
  const [data, setData] = useState([]);

  const auth = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      setStatus("fetching");
      const res = await axios.get(`${endpoint}/${path}`, auth);
      if (res) {
        setData(res.data);
      }
      setStatus("fetched");
    };

    fetchData();
  }, [path]);

  return { status, data };
};

export const sendPostRequest = async (path, params) => {
  const auth = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.post(`${endpoint}/${path}`, params, auth);

  return res.data;
};

export const sendGetRequest = async (path, params) => {
  const auth = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.get(`${endpoint}/${path}`, auth);

  return res.data;
};
